<template>
	<section class="text" v-html="copy"></section>
</template>

<script>
import PointerHoverMixin from '@/mixins/pointerHover';
export default {
	mixins: [PointerHoverMixin],
	props: {
		copy: String
	},
	mounted() {
		this.addLinksListener();
	},
	updated() {
		this.addLinksListener()
	},
	beforeDestroy() {
		this.removeLinksListener();
	}
}
</script>

<style lang="scss" scoped>
.text {
	@include moduleSpacing;
	width: 100%;

	@include fontCopy;
	@include textFormat;

	@include mq($from: m) {
		@include gridColumn(m, 15, 1, false, true);
	}

	@include mq($from: xl) {
		@include gridColumn(xl, 13, 2, false, true);
	}
}

</style>